import { useIntl } from '@weenat/wintl';
import isNil from 'lodash-es/isNil';
import moment from 'moment-timezone';
import { useClient } from '../../ClientProvider';
import { NetworkType } from '../../enums';
import useMutation from '../../useMutation';
import { canUser, ops } from '../access';
const actionsIds = ['view_farm_plots', 'convert', 'upgrade', 'remove_from_network'];
export const useAdherentFarmActions = ({ adherentFarm, org, onError, onOrgRemovalSuccess, onConversionSuccess }) => {
    const { t } = useIntl();
    const client = useClient();
    const [removeOrgFromNetwork, removeOrgFromNetworkState] = useMutation(client.networkOrgs.remove(adherentFarm?.id), {
        onSuccess: onOrgRemovalSuccess,
        onError
    });
    const [convertToPaid, convertToPaidState] = useMutation(client.networkOrgs.convertToPaidNetwork(adherentFarm?.id), {
        onSuccess: onConversionSuccess,
        onError
    });
    const actions = [];
    if (!isNil(adherentFarm) && !isNil(org)) {
        const untilAsNumber = !isNil(adherentFarm.until)
            ? parseInt(adherentFarm?.until, 10)
            : null;
        const isUntilAfterNow = !isNil(adherentFarm.until) && moment.unix(parseInt(adherentFarm.until, 10)).isAfter(moment());
        const isActiveFarm = isNil(untilAsNumber) || isUntilAfterNow;
        const isModifiable = isNil(adherentFarm)
            ? false
            : (isNil(adherentFarm.until) && isNil(adherentFarm.convertedAt)) || isUntilAfterNow;
        const canEditMembersAndModify = canUser(ops.edit, 'networks', { organization: org }) && isModifiable;
        if (isActiveFarm) {
            actions.push({
                id: 'view_farm_plots',
                to: `/farms/${adherentFarm.org.id}`,
                label: t('models.plot.actions.view_plots'),
                iconName: 'PlotsFilled'
            });
        }
        if (isActiveFarm && canEditMembersAndModify) {
            if (adherentFarm.isTrial && isNil(adherentFarm.convertedAt)) {
                actions.push({
                    id: 'convert',
                    label: t('models.networkOrganization.actions.convert_to_paying_member'),
                    onPress: async () => await convertToPaid(),
                    state: convertToPaidState,
                    iconName: 'RequestQuote',
                    needConfirmation: true
                });
            }
            else {
                if (org.networkType !== NetworkType.community)
                    actions.push({
                        id: 'upgrade',
                        to: `/farms/${org.id}/admin/network/members/${adherentFarm.id}/upgrade`,
                        label: t('breadcrumbs./farms/*/admin/network/members/*/upgrade'),
                        iconName: 'WeenatLogo'
                    });
            }
            actions.push({
                id: 'remove_from_network',
                onPress: async () => await removeOrgFromNetwork(),
                label: t('models.networkOrganization.actions.remove', { capitalize: true }),
                iconName: 'Close',
                state: removeOrgFromNetworkState,
                isDanger: true,
                needConfirmation: true
            });
        }
    }
    return actions;
};
